












































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import fieldData, { RecyclingFacility } from "@/ts/FormData";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import { IRecyclingFacilityApplicationVueModel } from "@/ts/models/IRecyclingFacilityApplicationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IRecyclingFacilityApplicationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class RecyclingFacilityAcceptedMaterials extends Vue {
    name: string = "RecyclingFacilityAcceptedMaterials";
    title: string = "";
    index: number = NaN;

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("AcceptedMaterials");

        if (this.$props.form.acceptedMaterials.length === 0) {
            this.$props.form.acceptedMaterials = RecyclingFacility.acceptedMaterials;
        } else {
            (this.$props.form.acceptedMaterials as ISelectItemVueModel[]).forEach((am, ix, arr) => {
                if (func.isNullOrEmpty(am.id)) {
                    am.id = fieldData.getNewId();
                }
            });
        }

        this.$watch("isDemoDebris", (n, o) => {
            if (!n) {
                this.$props.form.acceptedDebrisDescription = null;
            }
        }, { immediate: true });

        this.$watch("isMotorVehicleParts", (n, o) => {
            if (!n) {
                this.$props.form.motorVehiclePartsOptions = [];
            }
        }, { immediate: true });

        this.$watch("isRubberTire", (n, o) => {
            if (!n) {
                this.$props.form.rubberTireStorageDescription = null;
            }
        }, { immediate: true });

        this.$watch("isMetalScrap", (n, o) => {
            if (!n) {
                this.$props.form.acceptedMetalScrapDescription = null;
            }
        }, { immediate: true });

    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    get isMaterialsError(): boolean {
        return !(this.$props.form.acceptedMaterials as ISelectItemVueModel[]).some(value => value.isSelected);
    }

    get isDemoDebris(): boolean {
        return this.getIsOptionSelected(1);
    }

    get isMotorVehicleParts(): boolean {
        let isSelected = this.getIsOptionSelected(2);
        if (isSelected && this.$props.form.motorVehiclePartsOptions.length === 0) {
            this.$props.form.motorVehiclePartsOptions = RecyclingFacility.motorVehiclePartsOptions;
        }
        return isSelected;
    }

    get isRubberTire(): boolean {
        return this.getIsOptionSelected(3);
    }

    get isMetalScrap(): boolean {
        return this.getIsOptionSelected(4);
    }
    
    get isDemoDebrisError(): boolean {
        return this.isDemoDebris && func.isNullOrEmpty(this.$props.form.acceptedDebrisDescription);
    }
    
    get isRubberTireError(): boolean {
        return this.isRubberTire && func.isNullOrEmpty(this.$props.form.rubberTireStorageDescription);
    }

    get isMetalScrapError(): boolean {
        return this.isMetalScrap && func.isNullOrEmpty(this.$props.form.acceptedMetalScrapDescription);
    }

    private getIsOptionSelected(opt: number): boolean {
        let item = (this.$props.form.acceptedMaterials as ISelectItemVueModel[]).find(value => value.name.endsWith(`*${opt}`));
        if (item === undefined || item === null) return false;
        return (item as ISelectItemVueModel).isSelected;
    }

    get hasErrors(): boolean {
        return this.isMaterialsError || this.isDemoDebrisError || this.isRubberTireError || this.isMetalScrapError;
    }
}
